import { Box, IconButton, Typography } from "@mui/material";
import {Cursor} from "../../fstn/cursor";
import {connect} from "react-redux";
import {DeleteSweep, PauseCircleFilledOutlined, PlayCircleFilledOutlined, SwapVerticalCircle, SwapVerticalCircleOutlined}
    from "@mui/icons-material";
import React, {useEffect, useRef, useState} from "react";
import {IDebugController} from "../../fstn/debugController";
import {updateFocus} from "../../redux/slices/editor";
import {FloatingDialog} from "../dialogs/FloatingDialog";

interface Props {
    cursor: Cursor | undefined
    debugController: IDebugController
    onClose: () => void
    updateFocus: (state: string) => void
}

function DebugDialog({cursor, debugController, onClose, updateFocus}: Props) {
    const [paused, setPaused] = useState(cursor?.paused);
    const [debugLog, setDebugLog] = useState<string []>([]);
    const [autoScroll, setAutoScroll] = useState(false);
    const logRef = useRef<HTMLDivElement>(null);
    const handleClickPlay = () => {
        if (cursor) {
            cursor.play();
            setPaused(false);
        }
    };
    const handleClickPause = () => {
        if (cursor) {
            cursor.pause();
            setPaused(true);
            updateFocus(cursor.state);
        }
    };
    const handleClickClearLog = () => {
        debugController.clearLog();
        setDebugLog(debugController.getLog());
    }
    const handleClickScroll = () => {
        setAutoScroll(! autoScroll);
    }

    useEffect(() => {
        if (cursor) {
            const delegate = () => {
                setPaused(cursor.paused);
                setDebugLog([...debugController.getLog()]);
                if (logRef.current !== null && autoScroll) {
                    logRef.current.scrollTop = logRef.current.scrollHeight;
                }
                if (cursor.paused) {
                    updateFocus(cursor.state);
                }
            };

            cursor.addUpdateDelegate(delegate);
            return () => cursor.removeUpdateDelegate(delegate);
        }
    }, [autoScroll, cursor, debugController, updateFocus]);
    return (
        <FloatingDialog title="Debug" tools={
            <Box>
                <IconButton color="inherit" size="small" title="Automatic scroll" onClick={handleClickScroll}>
                    {autoScroll ? <SwapVerticalCircle/> : <SwapVerticalCircleOutlined/>}
                </IconButton>
                <IconButton color="inherit" size="small" title="Clear the log" onClick={handleClickClearLog}>
                    <DeleteSweep/>
                </IconButton>
                <IconButton color="inherit" disabled={paused} size="small"
                            title="Pause the game" onClick={handleClickPause}>
                    <PauseCircleFilledOutlined/>
                </IconButton>
                <IconButton color="inherit" disabled={! paused} edge="end" size="small"
                            title="Unpause the game" onClick={handleClickPlay}>
                    <PlayCircleFilledOutlined/>
                </IconButton>
            </Box>
        } onClose={onClose}>
            <div ref={logRef}>
                {debugLog.map((line, index) => (
                    <Typography key={index} variant="body2">{line}</Typography>
                ))}
            </div>
        </FloatingDialog>
    );
}

const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
    updateFocus,
})(DebugDialog);
